<template>
  <div>
    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <BaseModal
      v-cloak
      :is-open="modalOpen"
      :disabled="isConfirmBtnDisabled"
      :confirm-button-is-href="true"
      :confirm-button-href="inviteHref"
      :header-text="$t('Invite the :count contacts to a job', { count: contactIds.length })"
      :confirm-button-text="$t('Continue')"
      modal-id="modal-trusted-contact-invite"
      @cancel="modalOpen = false"
    >
      <div class="p-t-15 p-b-15" style="min-height: 250px">
        <div class="row">
          <div class="col-sm-6">
            <p>
              <a
                :class="{ 'btn-primary': isContactWithNewJobBrief }"
                href="#"
                class="btn btn-default btn-block btn-md btn-rich m-b-10"
                @click="setContactWithNewJobBrief"
              >
                {{ $t('Create new job brief') }}
              </a>
            </p>

            <div v-if="isContactWithNewJobBrief">
              <p>
                <span class="c-gray">
                  {{
                    $t('You can rapidly create a short job brief, and invite the contacts to bid.')
                  }}
                </span>
                <br />
                <span class="f-500 c-black">
                  {{ $t('Click the button to continue.') }}
                </span>
              </p>
            </div>
          </div>
          <div class="col-sm-6">
            <p>
              <a
                :class="{ 'btn-primary': isContactWithExistingJobPost }"
                href="#"
                class="btn btn-default btn-block btn-md btn-rich m-b-10"
                @click="setContactWithExistingJobPost"
              >
                {{ $t('Invite for existing job post') }}
              </a>
            </p>

            <div v-if="isContactWithExistingJobPost">
              <label class="f-500 c-black">{{ $t('Select job post') }}</label>
              <select
                v-if="me.activeAccount.jobsInvitableForFreelancer.length > 0"
                v-model="job"
                class="form-control required f-13"
                name="yjob_id"
                required="required"
              >
                <option value="">
                  {{ $apollo.loading ? $t('Loading') : $t('Select') }}
                </option>
                <template v-if="!$apollo.loading">
                  <option
                    v-for="job in me.activeAccount.jobsInvitableForFreelancer"
                    :key="job.localId"
                    :value="job.localId"
                  >
                    {{ job.name.substring(0, 50) }}
                  </option>
                </template>
              </select>
              <div v-if="me.activeAccount.jobsInvitableForFreelancer.length == 0">
                <em>
                  {{ $t('You do not have any published job posts to use for invitations!') }}
                </em>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
      <BaseHtmlForm ref="form" :action="inviteHref" method="POST" append-user-and-account>
        <input :value="contactIds" name="preselected_freelancer_ids" type="hidden" />
      </BaseHtmlForm>
    </BaseModal>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  apollo: {
    me: gql`
      query getJobsInvitableForFreelancer {
        me {
          globalId
          activeAccount {
            globalId
            ... on Company {
              jobsInvitableForFreelancer {
                globalId
                localId
                name
              }
            }
          }
        }
      }
    `,
  },
  props: {
    contactIds: { type: Array, required: true },
  },
  data() {
    return {
      modalOpen: false,
      saveState: 'fresh',
      job: '',
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      contactWithExistingJobPost: false,
      contactWithNewJobBrief: false,
    }
  },
  computed: {
    isSelectionMade() {
      return !!this.job
    },
    inviteHref() {
      if (this.isContactWithNewJobBrief) {
        return `/job/create-brief?preselected_freelancer_ids=${this.contactIds.join(',')}`
      }
      return `/job/${this.job}/contact-invites?preselected_freelancer_ids=${this.contactIds.join(
        ',',
      )}`
    },
    isContactWithNewJobBrief() {
      return this.contactWithNewJobBrief
    },
    isContactWithExistingJobPost() {
      return this.contactWithExistingJobPost
    },
    isConfirmBtnDisabled() {
      if (this.isContactWithNewJobBrief) {
        return false
      }
      return !this.isSelectionMade
    },
  },
  methods: {
    positiveResponse() {
      this.$refs.form.submit()
    },
    triggerTheModal() {
      this.modalOpen = true
    },
    setContactWithNewJobBrief() {
      this.contactWithNewJobBrief = true
      this.contactWithExistingJobPost = false
      return false
    },
    setContactWithExistingJobPost() {
      this.contactWithNewJobBrief = false
      this.contactWithExistingJobPost = true
      return false
    },
  },
}
</script>

<style scoped lang="scss"></style>
